import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCallMerge",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, f, a) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--call-merge"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Call Merge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.647 1.646a.5.5 0 0 1 .707 0l1.5 1.5a.5.5 0 1 1-.707.708L6.5 3.207v2.465a2.5 2.5 0 0 1-.732 1.767l-2.914 2.915a.5.5 0 0 1-.707-.708L5.06 6.732a1.5 1.5 0 0 0 .44-1.06V3.207l-.647.647a.5.5 0 1 1-.707-.708l1.5-1.5Zm1.5 6a.5.5 0 0 1 .707 0l2 2a.5.5 0 1 1-.707.708l-2-2a.5.5 0 0 1 0-.708Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ s(c, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=call-merge.js.map
